export const FileManagerEndpoints = {
  edit: (id: string) => `/file-manager/edit/${id}`,
  uploadFile: '/file-manager/upload/file',
  uploadUrl: '/file-manager/upload/url',
  list: '/file-manager/list',
  export: '/file-manager/export',
  find: (id: string) => `/file-manager/${id}`,
  delete: (id: string) => `/file-manager/del/${id}`,
  systemStorageDetails: '/file-manager/system-store-details',
};
